import { UploadZone } from "@components:UploadZone";
import { useToasterStoreActions } from "@stores:global";
import { useTranslation } from "react-i18next";

import { DropZoneProps } from "../types";
import { validateFile } from "../utils/fileHelpers";
import { DocumentTypeIcon } from "./DocumentTypeIcon";

export const DropZone = ({
  onFileSelect,
  accept,
  maxSizeMB,
  disabled = false,
  selectedFile = null,
  hint,
}: DropZoneProps) => {
  const { t } = useTranslation();
  const toastActions = useToasterStoreActions();

  const handleFileSelect = (file: File) => {
    const validation = validateFile(file, maxSizeMB, t);
    if (validation.valid) {
      onFileSelect(file);
    } else {
      toastActions.setToaster({
        variant: "error",
        message: validation.error || t("translation.errors.invalidFile"),
        open: true,
      });
    }
  };

  return (
    <UploadZone
      size="default"
      onFileSelect={handleFileSelect}
      selectedFile={selectedFile}
      accept={accept}
      disabled={disabled}
      title={t("translation.dropzone.title")}
      subtitle={t("translation.dropzone.subtitle")}
      hint={hint}
      fileIcon={
        selectedFile ? (
          <DocumentTypeIcon size="medium" filename={selectedFile.name} />
        ) : undefined
      }
    />
  );
};
